import { MainInner } from "@/styles/global";
import * as React from "react";

import Bang1 from "@/src/assets/Bang1.svg";
import Bang2 from "@/src/assets/Bang2.svg";
import Bang3 from "@/src/assets/Bang3.svg";
import Bang4 from "@/src/assets/Bang4.svg";
import Bang5 from "@/src/assets/Bang5.svg";
import Bang6 from "@/src/assets/Bang6.svg";
import Bang7 from "@/src/assets/Bang7.svg";
import Bang8 from "@/src/assets/Bang8.svg";

import S from "./Footer.style";
import useFooterData from "./useFooterData";

const Footer: React.FC = () => {
  const data = useFooterData();

  const { stockholm, copenhagen, socialMedia } = data.footer;

  const Stockholm = () => (
    <S.FooterSection>
      <S.Title>{stockholm.title}</S.Title>
      <S.ContactWrapper>
        <S.Contact>
          <S.Text>{stockholm.address.street}</S.Text>
          <S.Text>
            {stockholm.address.zip}, {stockholm.address.city}
          </S.Text>
          <S.Text>{stockholm.address.country}</S.Text>
          <S.Text>{stockholm.address.phone}</S.Text>
        </S.Contact>
        <S.Contact>
          {stockholm.contacts.contact.map((contact, i) => (
            <React.Fragment key={i}>
              <S.TextBold>{contact.title}</S.TextBold>
              <S.Text>
                <a href={`mailto:${contact.email}`} target="_blank">
                  {contact.email}
                </a>
              </S.Text>
            </React.Fragment>
          ))}
        </S.Contact>
      </S.ContactWrapper>
    </S.FooterSection>
  );
  const Copenhagen = () => (
    <S.FooterSection>
      <S.Title>{copenhagen.title}</S.Title>
      <S.ContactWrapper>
        <S.Contact>
          <S.Text>{copenhagen.address.street}</S.Text>
          <S.Text>
            {copenhagen.address.zip}, {copenhagen.address.city}
          </S.Text>
          <S.Text>{copenhagen.address.country}</S.Text>
          <S.Text>{copenhagen.address.phone}</S.Text>
        </S.Contact>
        <S.Contact>
          {copenhagen.contacts.contact.map((contact, i) => (
            <React.Fragment key={i}>
              <S.TextBold>{contact.title}</S.TextBold>
              <S.Text>
                <a href={`mailto:${contact.email}`} target="_blank">
                  {contact.email}
                </a>
              </S.Text>
            </React.Fragment>
          ))}
        </S.Contact>
      </S.ContactWrapper>
    </S.FooterSection>
  );

  const SocialMedia = () => (
    <S.SocialMediaWrapper>
      <S.TextBold>{socialMedia.title && socialMedia.title}</S.TextBold>
      <S.SocialMediaLinkWrapper>
        {socialMedia.links.map((link, i) => (
          <S.SocialMediaLink key={i} href={link.link.url} target="_blank">
            {link.link.title}
          </S.SocialMediaLink>
        ))}
      </S.SocialMediaLinkWrapper>
    </S.SocialMediaWrapper>
  );

  const Animation = () => (
    <S.Animation>
      <Bang1 className="part1 animation-part" />
      <Bang2 className="part2 animation-part" />
      <Bang3 className="part3 animation-part" />
      <Bang4 className="part4 animation-part" />
      <Bang5 className="part5 animation-part" />
      <Bang6 className="part6 animation-part" />
      <Bang7 className="part7 animation-part" />
      <Bang8 className="part8 animation-part" />
    </S.Animation>
  );

  return (
    <S.Container>
      <MainInner>
        <S.FooterInner>
          <S.Wrapper>
            {stockholm && <Stockholm />}
            {copenhagen && <Copenhagen />}
            {socialMedia && <SocialMedia />}
          </S.Wrapper>
          <S.AnimationWrapper>
            <Animation />
          </S.AnimationWrapper>
        </S.FooterInner>
      </MainInner>
    </S.Container>
  );
};

export default Footer;
